<template>
    <v-app-bar app color="primary" dark>
        <v-app-bar-nav-icon @click="handleDrawerToggle"/>
        <v-toolbar-title/>
        <v-spacer/>
        <v-btn @click="handleFullScreen()" icon>
            <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn @click="handleLogout()" icon>
            <v-icon>logout</v-icon>
        </v-btn>
        <v-menu
                :nudge-bottom="10"
                offset-y
                origin="center center"
                transition="scale-transition"
        >
            <v-btn icon large>
                <v-avatar size="30px">
                    <v-icon>account_circle</v-icon>
                </v-avatar>
            </v-btn>
            <v-list class="pa-0">
                <!--                <v-list-tile-->
                <!--                        v-for="(item, index) in items"-->
                <!--                        :to="!item.href ? { name: item.name } : null"-->
                <!--                        :href="item.href"-->
                <!--                        @click="item.click"-->
                <!--                        ripple="ripple"-->
                <!--                        :disabled="item.disabled"-->
                <!--                        :target="item.target"-->
                <!--                        rel="noopener"-->
                <!--                        :key="index"-->
                <!--                >-->
                <!--                    <v-list-tile-action v-if="item.icon">-->
                <!--                        <v-icon>{{ item.icon }}</v-icon>-->
                <!--                    </v-list-tile-action>-->
                <!--                    <v-list-tile-content>-->
                <!--                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>-->
                <!--                    </v-list-tile-content>-->
                <!--                </v-list-tile>-->
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    export default {
        name: "AppHeader",
        methods: {
            handleDrawerToggle() {
                window.app.$emit("APP_DRAWER_TOGGLED");
            },
            handleFullScreen() {
                window.app.$emit("APP_FULLSCREEN");
            },
            handleLogout() {
                window.app.$emit("APP_LOGOUT");
            }
        }
    }
</script>